// extracted by mini-css-extract-plugin
module.exports = {"dot":"qwwOot","blink":"wky8q1"};